import React, { useState, useContext, useEffect } from "react";

import ReactDOM from "react-dom";
import { useParams } from "react-router-dom";

import "../components/profile/Profile.scss";
import profilePic from "../assets/images/profile.png";
import user from "../assets/images/Icon awesome-user-alt.png";

import ProfileDetail from "components/profile/ProfileDetail";
import TwitteModal from "components/common/twitte/TwitteModal";
import twitteContext from "context/twitteContext";
import AuthenticationContext from "../Authentication/AuthenticationContext.ts";
import axios from "axios";

const Profile = () => {
  const { twitte, twittes, setTwittes, updater } = useContext(twitteContext);
  const params = useParams();
  const auth = useContext(AuthenticationContext);
  const [profile, setProfile] = useState({
    profilePic: "",
    fName_lName: "",
    name: "",
    id: "",
    email: "",
    phone: "",
    about: "",
    accountStatus: false,
    countPrediction: 0,
    successfulPrediction: 0,
    PL: 0,
  });
  async function apihandler() {
    let fd = new FormData();
    fd.append("muid", auth.userInfo.id);
    // fd.append("muid", 3);
    await axios
      .post("http://cryptozoom.tatdemo.ir/api2/get_twit", fd)
      .then((res) => {
        let temp;
        temp = res.data.twits.sort(function (a, b) {
          return b.main_twit[0].mtm - a.main_twit[0].mtm;
        });
        setTwittes(temp);
      });
    fd = new FormData();
    fd.append("token", auth.userInfo.token);
    fd.append("muid", params.id);
    await axios
      .post("http://cryptozoom.tatdemo.ir/apimain/get_user_profile", fd)
      .then((res) => {
        if (res.data.status == 1) {
          let { data } = res;
          setProfile({
            id: data.info.username,
            email: data.info.email,
            fName_lName: data.info.fullname,
            name: data.info.nikname,
            phone: data.info.mobile,
            PL: data.info.signalbalance,
            about: data.info.bio,
            accountStatus: data.info.main_status,
            countPrediction: data.info.signal_count,
            profilePic: data.info.profilepic,
            successfulPrediction: data.info.winrate,
          });
        }
      });
  }
  useEffect(() => {
    apihandler();
  }, [updater]);

  return (
    <>
      {twittes.length != 0 ? (
        <>
          <div>
            <div className="container1 profile">
              <div className="header"></div>
              <ProfileDetail profile={profile} setProfile={setProfile} />
            </div>
          </div>
          {twitte != null
            ? ReactDOM.createPortal(
                <TwitteModal />,
                document.getElementById("modals")
              )
            : ""}
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Profile;
